import React from 'react'

import { PageTitle, TextContent } from '../../index'

export default () => (
  <>
    <PageTitle>Introduction to the CPCS Renewal Test Tool - CPD e-Learning</PageTitle>
    <TextContent>
      <p>
        The CPCS CPD e-Learning is an important step in the process towards maintaining skills,
        knowledge and competency of the cardholder.
      </p>
      <p>
        The CPCS CPD courses are replacing CPCS Renewal Tests so cardholders will no longer be
        required to sit a test to renew, instead using the tool below to select a CPD course to
        continue their professional development.
      </p>
    </TextContent>
    <PageTitle>What is CPD?</PageTitle>
    <TextContent>
      <p>
        CPD stands for Continuing Professional Development. It is an ongoing and planned learning
        and development process to increase your knowledge, experiences and understanding. For CPCS
        this will be specific to one of five modules covering different topic areas of plant
        construction.
      </p>
      <ul>
        <li>Earth Moving and Compaction</li>
        <li>Lifting and Lifting Equipment</li>
        <li>Piling and Pumping of Materials</li>
        <li>Lifting Supervision and Management</li>
        <li>Demolition</li>
      </ul>
      <p>
        There are no tests as a part of the CPD e-Learning however there are some confirmatory
        questions that will need to be answered to progress through the CPD e-Learning.
      </p>
      <div className="bottom-content">
        <div>
          <span>
            Further information about the CPD e-Learning is available on the NOCN website{' '}
          </span>
          <a
            href="https://cpcs.nocn.org.uk/cpcs"
            target="_blank"
            rel="noopener noreferrer"
            className="external-link"
          >
            <strong>cpcs.nocn.org.uk/cpcs</strong>
          </a>
        </div>
        <div>
          <span>Alternatively you can call our CPCS Helpline on </span>
          <a href="tel:+03009991177" className="external-link">
            <strong>0300 999 1177</strong>
          </a>
        </div>
      </div>
    </TextContent>
  </>
)
